import React, { useContext } from "react";
import styled from "styled-components";
import { UIContext, VIEW_CONSTS } from "../../contexts/UIContext";
import { DataContext } from "../../contexts/DataContext";
import { APIContext } from "../../contexts/APIContext";
import { Button } from "../../Theme/Hyper";
import useLocalStorage from "../../Hooks/useLocalStorage";
import { ClockContext } from "../../contexts/ClockContext";

const TeamNamePanel = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1em;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  height: 7vh;
`;
const Team = styled.div`
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  display: flex;
  width: 40%;
  align-items: center;
  height: 54px;
`;
const Middle = styled.div`
  display: flex;
  width: 20%;
  justify-content: space-evenly;
  align-items: center;
  margin-top: -10px;
`;
const TeamName = styled.div`
  padding-left: ${(props) => (props.home ? "0.5em" : "")};
  margin-left: ${(props) => (props.home ? "auto" : "")};
  display: flex;
  font-size: 1.5em;

  width: 100%;
`;
const Score = styled.div`
  display: flex;
  font-size: 3em;
  padding-left: 0.5em;
  padding-right: 0.5em;
  align-items: center;
  justify-content: center;

  border-radius: 2px;
`;
const Kits = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 10px;
  justify-content: center;
  align-items: center;
  width: 100px;
`;
const Kit = styled.div`
  display: flex;
  width: 100%;
  font-size: 15px;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: ${(props) => (props.selected ? "#db0a41" : "#202731")};
  margin: 3px;
`;
export default function TeamNames({
  setGoalScored,
  game,
  setSelectedPlayer,
  stream = false,
}) {
  const {
    setView,
    selectedTeam,
    setGoal,
    homeKit,
    setHomeKit,
    awayKit,
    setAwayKit,
  } = useContext(UIContext);
  const { updateGame } = useContext(APIContext);
  const { homeScore, awayScore } = useContext(ClockContext);

  let homeBGColour = "";

  let awayBGColour = "";

  return (
    <TeamNamePanel>
      <Kits>
        Kit
        <Kit
          selected={homeKit === "home"}
          onClick={() => {
            setHomeKit("home");
          }}
        >
          {game?.home_team?.variables?.home_clock_bg}
        </Kit>
        <Kit
          selected={homeKit === "away"}
          onClick={() => {
            setHomeKit("away");
          }}
        >
          {game?.home_team?.variables?.away_clock_bg}
        </Kit>
      </Kits>

      <Team
        style={{
          borderBottom:
            "3px solid " + (homeBGColour ? homeBGColour : "rgba(0,0,0,0)"),
          opacity:
            !selectedTeam || selectedTeam._id === game.home_team._id
              ? "1"
              : ".2",
        }}
      >
        <TeamName home style={{ display: "flex", justifyContent: "end" }}>
          {game.home_team?.name} ({game.home_team?.code})
        </TeamName>
        <Score
          onContextMenu={(e) => {
            e.preventDefault();
          }}
        >
          {!stream && game?.scores_by_quarter?.home?.goals}
          {stream && homeScore}
        </Score>
      </Team>
      <Middle></Middle>
      <Team
        style={{
          borderBottom:
            "3px solid " + (awayBGColour ? awayBGColour : "rgba(0,0,0,0)"),
          opacity:
            !selectedTeam || selectedTeam._id === game.away_team._id
              ? "1"
              : ".2",
        }}
      >
        <Score
          right
          onContextMenu={(e) => {
            e.preventDefault();
          }}
        >
          {!stream && game?.scores_by_quarter?.away?.goals}
          {stream && awayScore}
        </Score>
        <TeamName>
          {game.away_team?.name} ({game.away_team?.code})
        </TeamName>
        <Kits>
          Kit
          <Kit
            selected={awayKit === "home"}
            onClick={() => {
              setAwayKit("home");
            }}
          >
            {game?.away_team?.variables?.home_clock_bg}
          </Kit>
          <Kit
            selected={awayKit === "away"}
            onClick={() => {
              setAwayKit("away");
            }}
          >
            {game?.away_team?.variables?.away_clock_bg}
          </Kit>
        </Kits>
      </Team>
    </TeamNamePanel>
  );
}
